import { MessageCircle } from "lucide-react";

export const SJI_WA_DISPLAY = "081397724555";
export const SJI_WA_INTL = "+62 813-9772-4555";
export const SJI_WA_NUMBER = "6281397724555";
export const SJI_WA_LINK = `https://wa.me/${SJI_WA_NUMBER}?text=${encodeURIComponent("Halo PT SJI, saya ingin bertanya tentang Salimbado Farm.")}`;

export const WaButton = ({ testid, className = "" }) => (
  <a href={SJI_WA_LINK} target="_blank" rel="noopener noreferrer" data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-bold text-emerald-950 transition-transform hover:-translate-y-0.5 hover:bg-[#20bd5a] ${className}`}>
    <MessageCircle className="h-4 w-4" />Chat WhatsApp
  </a>
);

export function ContactSJI({ testid = "contact-sji" }) {
  return (
    <section className="pb-16 sm:pb-20" data-testid={testid}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 rounded-2xl border border-emerald-900/10 bg-emerald-50 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700">Kontak PT SJI</p>
            <p className="mt-1 text-lg font-bold text-slate-900">Butuh Informasi? Hubungi PT SJI</p>
            <p className="mt-1 text-sm text-slate-600">Pengajuan lahan, investasi, Pengelola Perorangan, Kelompok Tani/Koperasi, dan penggunaan Salimbado Farm.</p>
            <p className="mt-2 text-sm text-slate-800">WhatsApp: <a href={SJI_WA_LINK} target="_blank" rel="noopener noreferrer" className="font-mono font-bold underline decoration-emerald-400 underline-offset-2" data-testid={`${testid}-number`}>{SJI_WA_DISPLAY}</a></p>
          </div>
          <WaButton testid={`${testid}-wa-btn`} className="self-start sm:self-auto" />
        </div>
      </div>
    </section>
  );
}
